<template>
    <b-container>
    <b-row align-h="center" class="mt-5">

      <b-col cols="12">
        <b-card-header class="card-main-header">
            <h3 class="text-center">Recent Donations!</h3>
        </b-card-header>

        <b-card class="card-main p-3 text-center" id="donation-history">

          <b-row>
            <b-col lg="6" class="mb-3">
                <b-form-group
                label="Month:"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="initialSortSelect"
                class="mb-0"
                >
                <b-form-select v-model="month" size="sm" @change="onMonthChange($event)"
                :options="monthList"></b-form-select>

                
                </b-form-group>
            </b-col>

            <b-col lg="6" class="mb-3">
                <b-form-group
                label="Year:"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="initialSortSelect"
                class="mb-0"
                >
                <b-form-select v-model="year" size="sm" @change="onYearChange($event)"
                :options="yearList"></b-form-select>

                
                </b-form-group>
            </b-col>
          </b-row>

          <b-table hover :items="donations" :fields="fields" :busy="isLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty>

            <template v-slot:empty="scope">
              <h5>No records found</h5>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>

        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import DonationApi from '@/services/DonationApi'
import EventBus from '@/services/EventBus'

export default {
  async created() {
    try {
      this.donations = await DonationApi.getDonations(moment().month() + 1, moment().year());
      this.toggleLoading();
    } catch (error) {
      EventBus.$emit('Error', error);
    }
  },
  data() {
    return {
      year: moment().year(),
      sortBy: 'created_at',
      sortDesc: true,
      isLoading: true,
      fields: [
        {
          key: 'created_at',
          label: 'Date',
          formatter: (value, key, item) => {
            return moment(String(value)).format('DD/MM/YYYY')
          },
          sortable: true
        },
        {
          key: 'User.username',
          label: 'Username',
          sortable: true
        },
        {
          key: 'amount',
          formatter: (value, key, item) => {
            return value + ' $';
          },
          sortable: true
        }
      ],
      donations: [],
      yearList: Array.from({ length: 5 }, (_, i) => moment().year() - i),
      monthList: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  computed: {
    month: function () {
        return this.monthList[moment().month()];
    },
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading;
    },
    async onMonthChange(value) {
        this.toggleLoading();
        this.donations = await DonationApi.getDonations(moment().month(value).format('M'), this.year);
        this.toggleLoading();
    },
    async onYearChange(value) {
        this.toggleLoading();
        this.donations = await DonationApi.getDonations(moment().month(this.month).format('M'), value);
        this.toggleLoading();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/History.vue